export default {"src":"/_next/static/image/public/images/ic_arrow.c60675cbdbf2befb796cd989413c5e30.svg","height":13,"width":15};